import { render, staticRenderFns } from "./toRecommend.vue?vue&type=template&id=0243dd2e&scoped=true"
import script from "./toRecommend.vue?vue&type=script&lang=ts"
export * from "./toRecommend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243dd2e",
  null
  
)

export default component.exports